module.exports = __webpack_public_path__ + "static/clem-onojeghuo-216ef03c54bc13771c5e1b8d8f8d5926.jpg";